import { hooksGenerator } from "../generic/all.hooks";
import CONFIG from "./registration.config";
export var usePaged = hooksGenerator({
    entityName: CONFIG.ENTITY_NAME,
    resource: CONFIG.RESOURCE,
    getBaseState: function (state) { return state[CONFIG.REDUCER_KEY]; },
}).usePaged;
